import { render, staticRenderFns } from "./BatchSubgroup.vue?vue&type=template&id=c57ef54c"
import script from "./BatchSubgroup.vue?vue&type=script&lang=js"
export * from "./BatchSubgroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports